import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import '../../css/WysiwygEditor.css';
const WysiwygEditor = ({ setValue, value, placeholder ="Write your email here...", editorRef }) => {
    const handleEditorChange = (value) => {
        setValue(value);
    };
    return (
        <div className="wysiwyg-editor">
            <ReactQuill
                value={value}
                onChange={handleEditorChange}
                modules={{
                    toolbar: [
                        [{ header: '1' }, { header: '2' }, { font: [] }],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        ['bold', 'italic', 'underline', 'strike'],
                        [{ color: [] }, { background: [] }],
                        [{ align: [] }],
                        ['link', 'image'],
                        ['clean']
                    ],
                }}
                placeholder={placeholder}
                ref={editorRef}
            />
        </div>
    );
};
export default WysiwygEditor;